// 5. Custom hooks and utilities
import {
  getResolvedApiBaseUrl,
  getResolvedExternalApiBaseUrl,
  getResolvedWsBaseUrl,
} from '~/config';

/**
 * Get API base URL from resolved client configuration.
 *
 * Returns whatever getResolvedApiBaseUrl() provides, defaulting to
 * this checkout's local API origin (LOCAL_API_ORIGIN) before config resolves. This is a direct origin, not
 * proxied: requests only route through the Vite dev proxy when config resolves
 * to a same-origin/relative URL (e.g. on the deaddrop.bezoan.com dev proxy).
 * For external URLs (e.g., MCP server URL to give users), use getExternalApiBaseUrl().
 */
export function getApiBaseUrl(): string {
  return getResolvedApiBaseUrl();
}

/**
 * Get external API base URL for displaying to users.
 * Unlike getApiBaseUrl(), this always returns a full URL that works externally.
 *
 * Use this for connection instructions where users need to copy the URL
 * into external tools like ChatGPT, Claude, etc.
 */
export function getExternalApiBaseUrl(): string {
  return getResolvedExternalApiBaseUrl();
}

/**
 * Get WebSocket base URL from resolved client configuration.
 */
export function getWsBaseUrl(): string {
  return getResolvedWsBaseUrl();
}
